import { render, staticRenderFns } from "./NationalRanking.vue?vue&type=template&id=48a8dde7&scoped=true"
import script from "./NationalRanking.vue?vue&type=script&lang=js"
export * from "./NationalRanking.vue?vue&type=script&lang=js"
import style0 from "./NationalRanking.vue?vue&type=style&index=0&id=48a8dde7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8dde7",
  null
  
)

export default component.exports